import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from "vue";
import { $get } from "@/plugins/api/api";
import { Paths } from "@/plugins/api/paths";
import Vuex from "@/store/index";
import { DateTime } from "luxon";
import { InputRules } from "@/rules";

type Props = {
  value?: Item;
};
type Emits = {
  (e: "input", value?: Item): void;
};
export type Item = {
  text: string;
  value: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'SubstituteHolidayFrom',
  props: {
    value: null
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", value?: Item): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value?: Item;
};




const modelValue = computed({
  get: () => props.value,
  set: val => emits("input", val)
});

const items = ref<Item[]>([]);

const getLegalHoliday = async () => {
  const userId = Vuex.state.user.incode;
  const affiliationId = Vuex.state.workIncode;
  const response = await $get<Item[]>(
    `${Paths.petition.search.legalHoliday}/${userId}/${affiliationId}`
  );
  if (response) items.value = response;
};

const formatDate = (item: Item) => {
  return DateTime.fromSQL(item.text)
    .setLocale("ja")
    .toFormat("yyyy年MM月dd日(EEE)");
};

onMounted(async () => {
  await getLegalHoliday();
});

return { __sfc: true,props, emits, modelValue, items, getLegalHoliday, formatDate, InputRules }
}

})